import { useEffect, useRef } from "react";

type DialogMutation = {
  isPending: boolean;
  isSuccess: boolean;
  reset: () => void;
};

// Keeps a dialog's submit button spinning from click until the dialog has
// fully closed. Mutations flip isPending off right after onSuccess closes the
// dialog, which reverts the button during the dialog's exit animation; holding
// loading through isSuccess avoids that flash. Resets on open so a reopened
// dialog doesn't start in the loading state.
export function useDialogMutationLoading(
  isOpen: boolean,
  mutation: DialogMutation
): boolean {
  const resetRef = useRef(mutation.reset);
  resetRef.current = mutation.reset;

  useEffect(() => {
    if (isOpen) resetRef.current();
  }, [isOpen]);

  return mutation.isPending || mutation.isSuccess;
}
